import {Injectable} from '@angular/core';
import {ProjectBusinessLogicFilterService} from './project-business-logic-filter.service';
import {combineLatest, Observable} from 'rxjs';
import {distinctUntilChanged, map} from 'rxjs/operators';
import {formatProjectBusinessLogicFilter} from './project-business-logic-filter-utils';
import {ProjectBusinessLogicFilterModel} from './project-business-logic-filter.model';

@Injectable({providedIn: 'root'})
export class ProjectBusinessLogicSyncFilterService {
  constructor(
    private projectBusinessLogicFilterService: ProjectBusinessLogicFilterService
  ) {
  }

  getFormattedProjectBusinessLogicFilter(): Observable<ProjectBusinessLogicFilterModel> {
    return combineLatest([
      this.projectBusinessLogicFilterService.selectedProjectId,
      this.projectBusinessLogicFilterService.selectedBusinessLogicId
    ]).pipe(
      map(([project, businessLogicId]) => formatProjectBusinessLogicFilter(project, businessLogicId)),
      distinctUntilChanged((prev, curr) =>
        prev.project_id === curr.project_id &&
        prev.business_logic_id === curr.business_logic_id
      )
    );
  }
}
